import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  acceptInvitationMemberOfPortfolio,
  createPortFolio,
  deletePortfolioMemberRequest,
  deletePortFolioWithId,
  editAnnualAssetGoalsWithRequest,
  editGrowthSchedulesWithRequest,
  getAllMemberInPortFolioRequest,
  getAllRolePermissionRequest,
  getAssetGoalsWithRequest,
  getGrowthSchedulesWithRequest,
  getPortFolioByUserId,
  getPortFolioWithId,
  inviteMemberPortFolio, updateCurrency, updatePortfolioName,
  updateTimeIPOPortfolio, verifyInvitationMemberOfPortfolio
} from 'APIs/portfolio.api'
import { push } from 'connected-react-router'
import { FAILURE, REQUEST, SUCCESS } from 'Stores'
import { getAllCustomerRequest } from 'APIs/accountInfo'
import { getLocalStorage, removeLocalStorage } from 'Utils'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { getAllPortfolioByUserId } from 'Modules/userList/store/actions'
import {
  getAllMemberInPortfolio as getAllMemberInPortfolioAction,
  getAssetGoals as getAssetGoalsAction,
  getGrowthSchedules as getGrowthSchedulesAction,
  getPortFolioById as getPortFolioByIdAction,
  getPortFolioByUserId as getPortFolioByUserIdAction,
  getPortFolioByUserIdWithAction as getPortFolioByUserIdWithActionCrud,
  getPermissionRoles as getPermissionRolesAction,
  getPortFolioByIdEdited as getPortFolioByIdEditedAction
} from './actions'
import {
  CREATE_PORTFOLIO,
  DELETE_MEMBER_PORTFOLIO,
  DELETE_PORTFOLIO_BY_ID,
  GET_ALL_CUSTOMER,
  GET_ALL_MEMBER_IN_PORTFOLIO,
  GET_ALL_ROLES_PERMISSION,
  GET_ASSET_GOALS,
  GET_GROWTH_SCHEDULES,
  GET_PORTFOLIO_BY_ID, GET_PORTFOLIO_BY_ID_EDIT,
  GET_PORTFOLIO_BY_USERID, GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD, GET_VERIFY_INVITE_MEMBER_PORTFOLIO,
  POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO,
  POST_INVITE_MEMBER_PORTFOLIO,
  UPDATE_CURRENCY,
  UPDATE_ASSET_GOALS,
  UPDATE_GROWTH_SCHEDULES, UPDATE_PORTFOLIO_NAME,
  UPDATE_TIME_IPO
} from './constants'
// eslint-disable-next-line no-unused-vars

export function* postCreatePortFolio(payload) {
  try {
    const { result, success } = yield call(createPortFolio, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(CREATE_PORTFOLIO),
        payload
      })
      if (result) {
        yield put(getAllPortfolioByUserId({ userId: payload.payload.userId }))
        yield put(push(`/user/${payload.payload.userId}/portfolio/${result?.id}/dashboard`))
        yield put(getPortFolioByIdAction({
          idUser: payload.payload.userId,
          id: result?.id
        }))
      }
    }
    yield put(getPortFolioByUserIdWithActionCrud())
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(CREATE_PORTFOLIO),
      error
    })
  }
}

export function* getPortFolioListByUserId({ payload }) {
  try {
    const { success, result } = yield call(getPortFolioByUserId, payload.idUser)
    if (success) {
      yield put({
        type: SUCCESS(GET_PORTFOLIO_BY_USERID),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_PORTFOLIO_BY_USERID),
      error
    })
  }
}

export function* getPortFolioListByUserIdCrud(payload) {
  try {
    const { success, result } = yield call(getPortFolioByUserId)
    if (success) {
      yield put({
        type: SUCCESS(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD),
        payload: result
      })
      switch (payload.payload) {
        case SUCCESS(DELETE_PORTFOLIO_BY_ID):
          break
        case SUCCESS(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO):
          yield put(push(`/dashboard/${getLocalStorage('portfolioId')}`))
          removeLocalStorage('portfolioId')
          break
        default:
          break
      }
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD),
      error
    })
  }
}

export function* getAllCustomer() {
  try {
    const { success, result } = yield call(getAllCustomerRequest)
    if (success) {
      yield put({
        type: SUCCESS(GET_ALL_CUSTOMER),
        payload: result.rows
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ALL_CUSTOMER),
      error
    })
  }
}

export function* getPortFolioById(payload) {
  try {
    const { success, result } = yield call(getPortFolioWithId, payload.payload)
    if (success) {
      yield all([put(getPermissionRolesAction({ id: payload.payload.id })),
        put(getAllMemberInPortfolioAction(payload.payload)),
        put(getAssetGoalsAction({ id: payload.payload.id })),
        put(getGrowthSchedulesAction({ id: payload.payload.id }))])
      yield put({
        type: SUCCESS(GET_PORTFOLIO_BY_ID),
        payload: result
      })
    }
  } catch (error) {
    if (error === 'Forbidden' || error === 'Portfolio not found') {
      push('/404')
    } else yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_PORTFOLIO_BY_ID),
      error
    })
  }
}

export function* getPortFolioByIdEdited(payload) {
  try {
    const { success, result } = yield call(getPortFolioWithId, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_PORTFOLIO_BY_ID_EDIT),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_PORTFOLIO_BY_ID_EDIT),
      error
    })
  }
}

export function* deletePortFolioById(payload) {
  try {
    const { success, result } = yield call(deletePortFolioWithId, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(DELETE_PORTFOLIO_BY_ID),
        payload: result
      })
      const data = yield call(getPortFolioByUserId, payload.payload.userId)
      if (data?.result?.length > 0) {
        yield put(getAllPortfolioByUserId({ userId: payload.payload.userId }))
        yield put(push(`/user/${payload.payload.userId}/portfolio/${data.result[0]?.id}/dashboard`))
      } else {
        payload.payload.callBack()
      }
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(DELETE_PORTFOLIO_BY_ID),
      error
    })
  }
}

export function* updateTimeIPO(payload) {
  try {
    const { success, result } = yield call(updateTimeIPOPortfolio, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(UPDATE_TIME_IPO),
        payload: result
      })
      yield put(getPortFolioByIdAction(payload.payload))
      // yield put(getGrowthSchedulesAction(payload.payload))
      // yield put(getAssetGoalsAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(UPDATE_TIME_IPO),
      error
    })
  }
}

export function* getAssetGoals(payload) {
  try {
    const { success, result } = yield call(getAssetGoalsWithRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_ASSET_GOALS),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ASSET_GOALS),
      error
    })
  }
}

export function* getGrowthSchedules(payload) {
  try {
    const { success, result } = yield call(getGrowthSchedulesWithRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_GROWTH_SCHEDULES),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_GROWTH_SCHEDULES),
      error
    })
  }
}

export function* putGrowthSchedules(payload) {
  try {
    const { success, result } = yield call(editGrowthSchedulesWithRequest, payload.payload)
    if (success) {
      if (payload?.growthSchedules?.length) {
        yield put({
          type: SUCCESS(GET_GROWTH_SCHEDULES),
          payload: payload.payload?.growthSchedules
        })
      }
      yield put({
        type: SUCCESS(UPDATE_GROWTH_SCHEDULES),
        payload: result
      })
      yield put(getPortFolioByIdAction(payload.payload))
      // yield put(getGrowthSchedulesAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(UPDATE_GROWTH_SCHEDULES),
      error
    })
  }
}

export function* putAnnualAssetGoals(payload) {
  try {
    const { success, result } = yield call(editAnnualAssetGoalsWithRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(UPDATE_ASSET_GOALS),
        payload: result
      })

      yield put(getAssetGoalsAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(UPDATE_ASSET_GOALS),
      error
    })
  }
}

export function* getAllRolePermission(payload) {
  try {
    const { success, result } = yield call(getAllRolePermissionRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_ALL_ROLES_PERMISSION),
        payload: result.rows
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ALL_ROLES_PERMISSION),
      error
    })
  }
}

export function* getAllMemberInPortFolio(payload) {
  try {
    const { success, result } = yield call(getAllMemberInPortFolioRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_ALL_MEMBER_IN_PORTFOLIO),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(GET_ALL_MEMBER_IN_PORTFOLIO),
      error
    })
  }
}

export function* postInviteMember(payload) {
  try {
    const { success, result } = yield call(inviteMemberPortFolio, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(POST_INVITE_MEMBER_PORTFOLIO),
        payload: result
      })

      yield put(getPortFolioByIdAction(payload.payload))
      yield put(getAllMemberInPortfolioAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put({
      type: FAILURE(POST_INVITE_MEMBER_PORTFOLIO),
      error
    })
  }
}

export function* postAcceptInvitationMemberOfPortfolio(payload) {
  try {
    const { success, result } = yield call(acceptInvitationMemberOfPortfolio, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO),
        payload: result
      })
      yield put(showModalMessage({ message: 'Invite Success', type: 'success' }))
      yield put(getPortFolioByUserIdWithActionCrud(SUCCESS(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO)))
      removeLocalStorage('inviteCode')
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(push('/404'))
    yield put({
      type: FAILURE(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO),
      error
    })
  }
}

export function* getVerifyInvitationMemberOfPortfolio(payload) {
  try {
    const { success, result } = yield call(verifyInvitationMemberOfPortfolio, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(GET_VERIFY_INVITE_MEMBER_PORTFOLIO),
        payload: result
      })
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))
    yield put(push('/404'))
    yield put({
      type: FAILURE(GET_VERIFY_INVITE_MEMBER_PORTFOLIO),
      error
    })
  }
}

export function* deletePortfolioMember(payload) {
  try {
    const { success, result } = yield call(deletePortfolioMemberRequest, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(DELETE_MEMBER_PORTFOLIO),
        payload: result
      })
      const { idUser, idUserCheck, setVisibleModalMember } = payload.payload
      if (Number(idUser) === idUserCheck) {
        const data = yield call(getPortFolioByUserId, payload.payload.idUser)
        if (data?.result.length > 0) {
          yield put(getAllPortfolioByUserId({ userId: payload.payload.idUser }))
          yield put(push(`/user/${payload.payload.idUser}/portfolio/${data.result[0]?.id}/dashboard`))
          setVisibleModalMember(false)
        } else {
          yield put(push('/user-list'))
        }
      } else {
        yield put(getPortFolioByIdAction(payload.payload))
      }
      yield put(getAllMemberInPortfolioAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))

    yield put({
      type: FAILURE(DELETE_MEMBER_PORTFOLIO),
      error
    })
  }
}

export function* updatePortfolioNameFunc(payload) {
  try {
    const { success, result } = yield call(updatePortfolioName, payload.payload)
    if (success) {
      yield put({
        type: SUCCESS(UPDATE_PORTFOLIO_NAME),
        payload: result
      })
      yield put(getAllPortfolioByUserId({ userId: payload.payload.idUser }))
      yield put(getPortFolioByUserIdAction(payload.payload))
      yield put(getPortFolioByIdEditedAction(payload.payload))
    }
  } catch (error) {
    yield put(showModalMessage({ message: error }))

    yield put({
      type: FAILURE(UPDATE_PORTFOLIO_NAME),
      error
    })
  }
}

export function* updateCurrencySaga(payload) {
  try {
    yield put(showOverlay())
    const { success } = yield call(updateCurrency, payload.payload)
    if (success) {
      yield put(getPortFolioByIdAction(payload.payload))
    }
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: error }))
  }
}

export default function* dashboardSaga() {
  yield takeLatest(REQUEST(CREATE_PORTFOLIO), postCreatePortFolio)
  yield takeLatest(REQUEST(GET_PORTFOLIO_BY_USERID), getPortFolioListByUserId)
  yield takeLatest(REQUEST(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD), getPortFolioListByUserIdCrud)
  yield takeLatest(REQUEST(GET_ALL_CUSTOMER), getAllCustomer)
  yield takeLatest(REQUEST(DELETE_PORTFOLIO_BY_ID), deletePortFolioById)
  yield takeLatest(REQUEST(GET_PORTFOLIO_BY_ID), getPortFolioById)
  yield takeLatest(REQUEST(UPDATE_TIME_IPO), updateTimeIPO)
  yield takeLatest(REQUEST(GET_ASSET_GOALS), getAssetGoals)
  yield takeLatest(REQUEST(GET_GROWTH_SCHEDULES), getGrowthSchedules)
  yield takeLatest(REQUEST(UPDATE_ASSET_GOALS), putAnnualAssetGoals)
  yield takeLatest(REQUEST(UPDATE_GROWTH_SCHEDULES), putGrowthSchedules)
  yield takeLatest(REQUEST(GET_ALL_ROLES_PERMISSION), getAllRolePermission)
  yield takeLatest(REQUEST(GET_ALL_MEMBER_IN_PORTFOLIO), getAllMemberInPortFolio)
  yield takeLatest(REQUEST(POST_INVITE_MEMBER_PORTFOLIO), postInviteMember)
  yield takeLatest(REQUEST(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO), postAcceptInvitationMemberOfPortfolio)
  yield takeLatest(REQUEST(GET_VERIFY_INVITE_MEMBER_PORTFOLIO), getVerifyInvitationMemberOfPortfolio)
  yield takeLatest(REQUEST(DELETE_MEMBER_PORTFOLIO), deletePortfolioMember)
  yield takeLatest(REQUEST(UPDATE_PORTFOLIO_NAME), updatePortfolioNameFunc)
  yield takeLatest(REQUEST(GET_PORTFOLIO_BY_ID_EDIT), getPortFolioByIdEdited)
  yield takeLatest(REQUEST(UPDATE_CURRENCY), updateCurrencySaga)
}
